import {IOppskrift} from '../types';
import db, {brukerRef} from 'utils/fireStore';
import {addDoc, collection, doc, setDoc} from 'firebase/firestore';
import {User} from 'firebase/auth';

export const addOppskrift = async (oppskrift: IOppskrift, user: User) => {
  if (oppskrift.id) {
    await setOppskrift(oppskrift, user);
  } else {
    const oppskrifterCollection = collection(db, 'oppskrifter');
    await addDoc(oppskrifterCollection, {...oppskrift, userId: brukerRef(user.uid)});
  }
};

export const setOppskrift = async (oppskrift: IOppskrift, user: User) => {
  const {id, ...felter} = oppskrift;
  if (id) {
    await setDoc(doc(db, 'oppskrifter', id), {...felter, userId: brukerRef(user.uid)});
  }
};
